/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandPagekit = createReactComponent("brand-pagekit", "IconBrandPagekit", [
  ["path", { d: "M12.077 20h-5.077v-16h11v14h-5.077", key: "svg-0" }]
]);

export { IconBrandPagekit as default };
//# sourceMappingURL=IconBrandPagekit.js.map
